function checkWeek(now) {
    const diaSemana = now.getDay();
    return diaSemana >= 1 && diaSemana <= 5;
}

function updateCountdown(cutOffTime) {
    const now = new Date();
    let timeDifference = cutOffTime.getTime() - now.getTime();
    timeDifference = Math.max(timeDifference, 0);
    const horasFaltantes = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutosFaltantes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const segundosFaltantes = Math.floor((timeDifference % (1000 * 60)) / 1000);

    document.getElementById("delivery-message").innerHTML = "Si compras ahora tu pedido llegará hoy.<br> Compra dentro de <span class='remaining-time'>" + Math.abs(horasFaltantes) + " horas, " + Math.abs(minutosFaltantes) + " minutos, y " + Math.abs(segundosFaltantes) + " segundos";
}

function deliveryMessage() {
    const now = new Date();
    const cutOffTime = new Date();

    if (checkWeek(now)) {
        // Establecer el horario de corte para viernes
        if (now.getDay() === 5) {
            cutOffTime.setHours(13, 0, 0); // Horario de corte para viernes a las 13:00
        } else {
            cutOffTime.setHours(13, 0, 0); // Horario de corte de lunes a jueves a las 13:00
        }

        if (now.getTime() < cutOffTime.getTime()) {
            updateCountdown(cutOffTime);
            setInterval(() => updateCountdown(cutOffTime), 1000);
        } else if (now.getDay() === 5) {
            // Es viernes después de la hora de corte
            document.getElementById("delivery-message").innerHTML = 'Si compras hoy tu pedido llegará el día <span class="remaining-time">Lunes</span>';
        } else {
            // Es de lunes a jueves después de la hora de corte
            document.getElementById("delivery-message").innerHTML = 'Si compras hoy tu pedido llega <span class="remaining-time">mañana</span>';
        }
    } else {
        // Es fin de semana
        document.getElementById("delivery-message").innerHTML = 'Si compras hoy tu pedido llegará el <span class="remaining-time">Lunes</span>';
    }
}

deliveryMessage();



document.addEventListener('DOMContentLoaded', function() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    let cutOffMessage = ""; // Inicializar el mensaje de horario de corte

    // De lunes a jueves (getDay() devuelve 1 para lunes, 2 para martes, ..., 5 para viernes)
    if (dayOfWeek >= 1 && dayOfWeek <= 4) {
        cutOffMessage = "Horario de corte: 13:00 hrs - No considera feriados";
    }
    // Viernes
    else if (dayOfWeek === 5) {
        cutOffMessage = "Horario de corte: 13:00 hrs - No considera feriados";
    }

    // Asegúrate de que el elemento con ID 'cut-off-time-message' exista en tu HTML
    document.getElementById("cut-off-time-message").innerHTML = cutOffMessage;
});

